/** InsCoder 2026-09-17 B + HP 26 image card carousel: swiper + floating prev / next navigation **/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-hp26-icc]';
  var SLIDER_SELECTOR = '[data-hp26-swiper]';

  function initSection(root) {
    if (!root || root.dataset.hp26IccReady === 'true') return;

    var sliderEl = root.querySelector(SLIDER_SELECTOR);
    if (!sliderEl) return;
    root.dataset.hp26IccReady = 'true';

    if (!window.Swiper || !sliderEl.querySelector('.swiper-slide')) return;

    new window.Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      /** InsCoder 2026-09-17 B + Mobile: 120px peek card + 12px gutter; desktop: 5 cards + 16px gutter **/
      breakpoints: {
        0: { slidesPerView: 'auto', spaceBetween: 12 },
        990: { slidesPerView: 5, spaceBetween: 16 }
      },
      /** InsCoder 2026-09-17 E + Mobile: 120px peek card + 12px gutter; desktop: 5 cards + 16px gutter **/
      navigation: {
        nextEl: root.querySelector('[data-hp26-next]'),
        prevEl: root.querySelector('[data-hp26-prev]')
      }
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;

    var root = target.dataset && target.dataset.hp26Icc !== undefined
      ? target
      : target.querySelector(ROOT_SELECTOR);

    if (root) initSection(root);
    else initAll();
  });
})();
/** InsCoder 2026-09-17 E + HP 26 image card carousel: swiper + floating prev / next navigation **/
